import React, { useState, useEffect } from 'react';

interface FloatingNavigationProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: Array<{
    id: string;
    label: string;
    icon: string;
  }>;
}

/**
 * Navegación flotante para móvil que aparece al hacer scroll
 */
const FloatingNavigation: React.FC<FloatingNavigationProps> = ({ 
  activeTab, 
  onTabChange, 
  tabs 
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const [lastScrollY, setLastScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const headerHeight = document.querySelector('.header')?.clientHeight || 80;
      
      // Mostrar navegación flotante después de pasar el header y tabs originales
      if (currentScrollY > headerHeight + 200 && currentScrollY > lastScrollY) {
        setIsVisible(true);
      } else if (currentScrollY < headerHeight + 100) {
        setIsVisible(false);
      }
      
      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollY]);

  return (
    <nav 
      className={`floating-navigation ${isVisible ? 'visible' : ''}`}
      aria-label="Navegación flotante"
    >
      <div className="floating-nav-container">
        <div className="floating-nav-background">
          <div className="nav-blur-effect"></div>
          <div className="nav-gradient"></div>
        </div>
        
        <ul className="floating-nav-list">
          {tabs.map((tab, index) => (
            <li key={tab.id} className="floating-nav-item">
              <button
                className={`floating-nav-button ${activeTab === tab.id ? 'active' : ''}`}
                onClick={() => onTabChange(tab.id)}
                aria-current={activeTab === tab.id ? 'page' : undefined}
                style={{ '--delay': `${index * 0.1}s` } as React.CSSProperties}
              >
                <div className="nav-button-content">
                  <div className="nav-icon-container">
                    <i className={tab.icon}></i>
                    <div className="icon-ripple"></div>
                  </div>
                  <span className="nav-label">{tab.label}</span>
                </div>
                <div className="nav-button-bg"></div>
                <div className="nav-active-indicator"></div>
              </button>
            </li>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default FloatingNavigation;